import { render, staticRenderFns } from "./SettingsInsertLinkPanel.vue?vue&type=template&id=4bce11ca"
import script from "./SettingsInsertLinkPanel.vue?vue&type=script&lang=ts"
export * from "./SettingsInsertLinkPanel.vue?vue&type=script&lang=ts"
import style0 from "./SettingsInsertLinkPanel.vue?vue&type=style&index=0&id=4bce11ca&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports